import Cookie from '@wetransfer/concorde-cookie';

import TransferConfig from '@module/transfer/config';

export const init = () => {
  // Configure Cookie
  Cookie.configure({
    path: '/',
    domain: window['__session__'].settings.cookie_domain,
    secure: location.protocol === 'https:',
  });

  // Disable feature: Parallel uploads
  if (Cookie.get('wt_noparallel') && Cookie.get('wt_noparallel') === '1') {
    TransferConfig.queue.parallel.max = 1;
  }
};

init();
